import { z } from '@football-kids/shared/z';

const OrderEntrySchema = z.object({
    productId: z.string(),
    productVariantId: z.string(),
    quantity: z.coerce.number().positive()
});

const OrderInvoiceSchema = z.object({
    vatNumber: z.string(),
    companyName: z.string()
});

export const orderSchema = z.object({
    cartId: z.string().min(1),
    lineItems: OrderEntrySchema.array().min(1, `Zamówienie musi mieć przynajmniej jedną pozycje`),
    shippingOptionId: z.string().min(1, "Musisz wybrać metode wysyłki"),
    additionalInfo: z.string(),
    invoice: OrderInvoiceSchema
});

export type OrderSchemaType = z.infer<typeof orderSchema>;

export const getDefaultOrder = () => ({
    cartId: null,
    accountId: null,
    shippingOptionId: null,
    lineItems: [
        {
            productId: null,
            productVariantId: null,
            quantity: 1
        }
    ],
    invoice: {
        vatNumber: '',
        companyName: ''
    },
    additionalInfo: '',
});
